import React, { useState, useEffect } from 'react';

import Header from '../../components/Header/Home/Header.js';
import logoTerraLAB from '../../assets/logos/logoTerraLAB.svg'
import logoOuvidoria from '../../assets/logos/logoOuvidoria.svg'
import './styles.css'

export default function AboutPage() {
    const [{ width }, setDimension] = useState({ width: window.innerWidth, height: window.innerHeight });

    const updateWindowDimensions = () => {
        setDimension({ width: window.innerWidth, height: window.innerHeight });
    }

    useEffect(() => {
        window.addEventListener('resize', updateWindowDimensions);
        return () => window.removeEventListener('resize', updateWindowDimensions);
    }, [])


    return (
        <div id='about-page'>
            <Header />
            {width > 540 ?
                <div className='container'>
                    <div className='container-column'>
                        
                        <div className='container-text'>
                            <h1 className ='title-text'>O site</h1>
                            <p className='about-text'>
                                Este é o "Segurança da Mulher", que apresenta níveis de risco de locais denunciados por pessoas identificadas com o gênero feminino, nos quais passaram por alguma experiência de violência física ou moral, importunação sexual ou desconforto. Clicando nos pontos sinalizados do mapa, é possível visualizar os detalhes dos relatos.
                                O aplicativo também disponibiliza espaço para o direito de resposta dos locais denunciados. 
                                Caso deseje criar sua própria denúncia ou responder a uma denúncia realizada à sua propriedade, baixe o aplicativo mobile e faça seu cadastro.
                            </p>
                            <br/>
                            <h1 className ='title-text'>Parceria</h1>
                            <p className='about-text'>
                                Este projeto é fruto de uma parceria entre a Ouvidoria Feminina e o laboratório TerraLAB da UFOP.
                            </p> <br/>

                            <div className='images'>
                                {/* <a href="http://www2.decom.ufop.br/terralab/" target="_blank" rel="noopener noreferrer" > */}
                                    <img src={logoOuvidoria} alt="ouvidoria"/>
                                {/* </a> */}

                                <a href="http://www2.decom.ufop.br/terralab/" target="_blank" rel="noopener noreferrer" className='image'>
                                    <img src={logoTerraLAB} alt="terralab"/>
                                </a> 
                            </div>
                            <br/>
                        </div>

                        
                    </div>

                    <div className='container-equipe'>
                        <h1 className ='title-text'>Equipe de desenvolvimento</h1>

                        <p className='about-text color-light'>Product Owner</p>
                        <p className='about-text'> &nbsp;&nbsp;&nbsp; Alan Gabriel da Silva Duarte e Iasmin Salvador</p>
                        <p className='about-text color-light'>Software Engineers</p>
                        <p className='about-text'> &nbsp;&nbsp;&nbsp;Rodrigo Silva, Emanuel Jesus Xavier, Carlos Magalhães, Vinicius de Paula e Bernardo Emery</p>
                        <p className='about-text color-light'>Site Reliability Engineers</p>
                        <p className='about-text'> &nbsp;&nbsp;&nbsp; Guilherme Carolino ROdrigues e time</p>
                        <p className='about-text color-light'>User eXperience Designers</p>
                        <p className='about-text'> &nbsp;&nbsp;&nbsp;  Arilton Aguilar e time</p>
                        <p className='about-text color-light'>Project Manager</p>
                        <p className='about-text'> &nbsp;&nbsp;&nbsp; Ramon Silveira Assis Barros</p>
                        <p className='about-text color-light'>DevOps Manager </p>
                        <p className='about-text'> &nbsp;&nbsp;&nbsp; Arilton Aguilar</p>
                        <p className='about-text color-light'>TerraLAB coordination  </p>
                        <p className='about-text'> &nbsp;&nbsp;&nbsp; Prof. Tiago G S Carneiro</p>
                        
                    </div> <br/><br/><br/> 
                </div>   

            :

                <div className='container-resp'>
                    <div className='container-column-resp'>
                        
                        <div className='container-text'>
                            <h1 className ='title-text'>O site</h1>
                            <p className='about-text'>
                                Este é o "Segurança da Mulher", que apresenta níveis de risco de locais denunciados por pessoas identificadas com o gênero feminino, nos quais passaram por alguma experiência de violência física ou moral, importunação sexual ou desconforto. Clicando nos pontos sinalizados do mapa, é possível visualizar os detalhes dos relatos.
                                O aplicativo também disponibiliza espaço para o direito de resposta dos locais denunciados. 
                                Caso deseje criar sua própria denúncia ou responder a uma denúncia realizada à sua propriedade, baixe o aplicativo mobile e faça seu cadastro.
                            </p>
                            <br/>
                            <h1 className ='title-text'>Parceria</h1>
                            <p className='about-text'>
                                Este projeto é fruto de uma parceria entre a Ouvidoria Feminina e o laboratório TerraLAB da UFOP.
                            </p> <br/>

                            <div className='images'>
                                <a href="http://www2.decom.ufop.br/terralab/" target="_blank" rel="noopener noreferrer" >
                                    <img src={logoOuvidoria} alt="ouvidoria"/>
                                </a>

                                <a href="http://www2.decom.ufop.br/terralab/" target="_blank" rel="noopener noreferrer" className='image'>
                                    <img src={logoTerraLAB} alt="terralab"/>
                                </a> 
                            </div>
                            <br/>
                        </div>

                        
                    </div>

                    <div className='container-equipe-resp'>
                        <h1 className ='title-text'>Equipe de desenvolvimento</h1>

                        <p className='about-text color-light'>Product Owner</p>
                        <p className='about-text'> &nbsp;&nbsp;&nbsp; Alan Gabriel da Silva Duarte</p>
                        <p className='about-text color-light'>Software Engineers</p>
                        <p className='about-text'> &nbsp;&nbsp;&nbsp;Rodrigo, Emanuel Jesus Xavier e Carlos Magalhães</p>
                        <p className='about-text color-light'>Site Reliability Engineers</p>
                        <p className='about-text'> &nbsp;&nbsp;&nbsp; Guilherme e time</p>
                        <p className='about-text color-light'>User eXperience Designers</p>
                        <p className='about-text'> &nbsp;&nbsp;&nbsp;  Arilton e time</p>
                        <p className='about-text color-light'>Project Manager</p>
                        <p className='about-text'> &nbsp;&nbsp;&nbsp; Ramon</p>
                        <p className='about-text color-light'>DevOps Manager </p>
                        <p className='about-text'> &nbsp;&nbsp;&nbsp; Arilton</p>
                        <p className='about-text color-light'>TerraLAB coordination  </p>
                        <p className='about-text'> &nbsp;&nbsp;&nbsp; Prof. Tiago G S Carneiro</p>
                        
                    </div>
                </div>   
                
            }
        </div>
    );
}